module.exports = __webpack_public_path__ + "img/gry_6.4a0ef2bd.png";